import { FC } from 'react';

import { EmbeddedContentDefinition } from 'modules/graphql';
import { useEditableFieldsContext } from 'modules/templateEditor/context/EditableFieldsContext';
import { useQueryPlacements } from '../hooks/useQueryPlacements';
import { Placement } from '../types';
import {
  PlacementSelectorContext,
  PlacementSelectorContextState,
} from './PlacementSelectorContext';

export const PlacementSelectorContextProvider: FC<React.PropsWithChildren<unknown>> = ({
  children,
}) => {
  const { placements: activePlacementsList, loading: activePlacementsLoading } =
    useQueryPlacements();
  const { placements: allPlacementsList, loading: allPlacementsLoading } =
    useQueryPlacements(false);

  const { liveTemplate } = useEditableFieldsContext();
  const embeddedContent = (liveTemplate?.mediumData || {}) as EmbeddedContentDefinition;
  const selectedPlacementId = embeddedContent?.placementId;

  const selectedPlacementDetails = allPlacementsList?.find(
    (placement: Placement) => placement.id === selectedPlacementId,
  );

  const value: PlacementSelectorContextState = {
    activePlacementsLoading,
    activePlacementsList,
    allPlacementsLoading,
    allPlacementsList,
    isSelectedPlacementArchived: !!selectedPlacementDetails?.isArchived,
    selectedPlacementDetails,
    selectedPlacementId,
  };

  return (
    <PlacementSelectorContext.Provider value={value}>{children}</PlacementSelectorContext.Provider>
  );
};
